@if (initialized) {
    <scheduler-component *ngIf="events"></scheduler-component>
}